
<router-outlet></router-outlet>
<div id="loading-spinner" *ngIf="loaderVisible"><p-progressSpinner></p-progressSpinner></div>
<p-toast [position]="'bottom-center'"></p-toast>